<script lang="ts">
  import { Col } from "sveltestrap";
  import Recentactivitydata from "../../../Data/ComponentData/WidgetData/Genral/RecentActivity.json";
  import { RECENTACTIVITY } from "../../../utils/Constant/Constant";
  import Card from "../../Core/Card.svelte";
</script>

<Col xl="4" md="6" class="box-col-12">
  <div>
    <Card
      cardProps="card-activity"
      cardHeaderprops="pb-0 d-flex justify-content-between align-items-center"
      headerTitle={RECENTACTIVITY}
    >
      <div slot="contentbody">
        <ul class="crm-activity">
          {#each Recentactivitydata.Recentavtivity as recentItem}
            <li class="media">
              <span class="me-3 {recentItem.color}">{recentItem.font}</span>
              <div class="align-self-center media-body">
                <h6 class="mt-0">{recentItem.title}</h6>
                <ul class="dates">
                  <li>{recentItem.date}</li>
                  <li>{recentItem.time}</li>
                </ul>
              </div>
            </li>
          {/each}
          <li class="media">
            <div class="align-self-center media-body">
              <ul class="dates">
                <li>25 July 2017</li>
                <li>20 hours ago</li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </Card>
  </div>
</Col>
